import Vuex from "vuex";
import cookie from "./modules/cookie";
import workflow from "./modules/workflow";
import toast from "./modules/toast";
import auth from "./modules/auth";
import socket_ws from "./modules/sockets.store";

import proyecto_v from "./modules/proyecto_v";
import restrictions from "./modules/restrictions";
import reports from "./modules/reports";
import depreciation from "./modules/depreciation";

const createStore = () => {
  return new Vuex.Store({
    modules: {
      cookie,
      toast,
      auth,
      workflow,
      proyecto_v,
      socket_ws,
      restrictions,
      reports,
      depreciation,
    },
  });
};

export default createStore;
